export class FollowVenueError extends Error {
  constructor(message) {
    super(message);
    this.name = "FollowVenueError";
    this.message = message;
  }
}
export class FollowArtistError extends Error {
  constructor(message) {
    super(message);
    this.name = "FollowArtistError";
    this.message = message;
  }
}
